import { core } from './idCore';
import { content } from './idContent';
import { system } from './idSystem';

export const id = {
    ...core,
    ...content,
    ...system,
};
